import { Button, ContentSection, Heading, Layout } from "@vwfs-bronson/bronson-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const CustomerPortalBox: React.FunctionComponent = () => {
    const { t } = useTranslation("customerportalbox");
    return (
        <ContentSection altBackground={true} className="u-mb-none">
            <Layout center>
                <Layout.Item default="3/4" s="1/1" className="u-text-center">
                    <Heading level={2}>{t("header")}</Heading>
                    <p>{t("text")}</p>
                    <Link to={"https://moncompte.vwfs.fr/"} target="_blank">
                        <Button type="button">{t("link")}</Button>
                    </Link>
                </Layout.Item>
            </Layout>
        </ContentSection>
    );
};

export default CustomerPortalBox;
